import axios from "axios";

const getHomeWidgets = async () => {
  const { data } = await axios.get("api/v1/settings/home-widgets");
  return data;
};

const updateHomeWidgets = async (payload) => {
  const { data } = await axios.put("api/v1/settings/home-widgets", payload);
  return data;
};

const ApiHomeWidgetsManagement = {
  getHomeWidgets,
  updateHomeWidgets
};

export default ApiHomeWidgetsManagement;